import { injectGlobal } from 'react-emotion';
import styled from 'react-emotion/macro';
import {
  width, space, color, themeGet, fontSize,
} from 'styled-system';
import { Button } from 'antd';

injectGlobal(`
  .DCRPFilterPopover {
    .ant-tree-switcher-icon {
      font-size: 21px !important;
    }

    .ant-popover-title {
      border-bottom: none;

      h5 {
        margin-top: 12px;
      }

      .ant-row {
        margin-right: 0 !important;
      }
    }

    .ant-popover-inner-content {
      padding-top: 0;
    }
  }
`);

export const FilterPanelButton = styled(Button)` &&& {
  ${space}
}`;

export const PopoverButton = styled('a')` &&& {
  ${width}
  ${space}
  ${color}
  ${fontSize}
  font-weight: 600;
  float: left;

  .anticon {
    margin-right: 8px;
    margin-top: 8px;
  }

  &:hover {
    color: ${themeGet('colors.clientPrimary')};
  }
}`;

export const ShowAppliedFilterWrapper = styled('div')` &&& {
  ${space}
  font-size: .8em;
  display: inline-block;
  width: calc(100% - 55px);
}`;

export const ShowAppliedFilterLabel = styled('b')` &&& {
  display: inline-block;
  width: 90px;
  vertical-align: middle;
}`;

export const InnerWrapper = styled('div')`
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 90px);
  user-select: none;
`;

export const FilterTag = styled('div')` &&& {
  display: inline-block;
  padding: 2px 5px;
  border-radius: 3px;
  color: #fff;
  margin: 2px 0px 2px 4px;
  text-transform: capitalize;
  ${color}
}`;
